import type { RecursivePartial } from '#root/types/utils'
import type { CollectionPointsConfig } from '#types/config/components/collectionPoints'

export default {
  viewBtnVariant: 'secondary',
} satisfies RecursivePartial<CollectionPointsConfig['search']>
